import { render, staticRenderFns } from "./BankTransactions.vue?vue&type=template&id=4955726b&scoped=true&"
import script from "./BankTransactions.vue?vue&type=script&lang=js&"
export * from "./BankTransactions.vue?vue&type=script&lang=js&"
import style0 from "./BankTransactions.vue?vue&type=style&index=0&id=4955726b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955726b",
  null
  
)

export default component.exports